/* eslint-env commonjs */
// Shim for nanoid/non-secure on web.
// The real nanoid@3.3.11 is "type":"module" and its ESM → CJS interop
// fails in @expo/webpack-config. This plain CJS version has no ambiguity.
// Implementation is identical to nanoid@3.3.11/non-secure/index.cjs.

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

let customAlphabet = (alphabet, defaultSize = 21) => {
  return (size = defaultSize) => {
    let id = '';
    let i = size | 0;
    while (i--) {
      id += alphabet[(Math.random() * alphabet.length) | 0];
    }
    return id;
  };
};

let nanoid = (size = 21) => {
  let id = '';
  let i = size | 0;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id;
};

// Use explicit exports (not module.exports = {}) so webpack can
// detect named exports for both CJS require() and ESM import {}.
exports.nanoid = nanoid;
exports.customAlphabet = customAlphabet;
